import * as ss from 'superstruct';
import { Id } from './types';

export const ExampleResource = ss.object({
  id: Id,
  fieldA: ss.string(),
  fieldB: ss.nullable(ss.optional(ss.number())),
});

export type ExampleResource = ss.Infer<typeof ExampleResource>;

export const mockExamples: ExampleResource[] = [
  {
    id: 1,
    fieldA: 'A',
  },
  {
    id: 2,
    fieldA: 'B',
  },
  {
    id: 3,
    fieldA: 'C',
  },
];
